import { useLocalSearchParams } from "expo-router";
import { ContactsScreen } from "@src/features/contacts/screens/ContactsScreen";

export default function SiteAlarmPage() {
  const { title } = useLocalSearchParams<{ title?: string }>();
  return <ContactsScreen title={title ?? "Site Alarm"} category="alarm" />;
}
